(function () {
  'use strict';

  var FORM_SELECTOR = '[data-canvas-configurator-simple]';
  var TRANSPARENT_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  var PRINT_PIXELS_PER_CM = 100;
  var PRINT_MAX_SIDE = 8000;
  var PRINT_JPEG_QUALITY = 0.92;

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function readJson(response) {
    return response.json().catch(function () {
      return {};
    });
  }

  function getErrorMessage(payload, fallback) {
    if (!payload) return fallback;

    if (typeof payload.error === 'string') {
      return payload.error;
    }

    if (payload.error && typeof payload.error.message === 'string') {
      return payload.error.message;
    }

    if (typeof payload.message === 'string') {
      return payload.message;
    }

    if (typeof payload.description === 'string') {
      return payload.description;
    }

    return fallback;
  }

  function getUploadConfig(form) {
    var provider = (form.dataset.uploadProvider || 'endpoint').trim();
    var uploadEndpoint = (form.dataset.uploadEndpoint || '').trim();
    var cloudName = (form.dataset.cloudinaryCloud || '').trim();
    var uploadPreset = (form.dataset.cloudinaryPreset || '').trim();

    if (provider === 'cloudinary') {
      if (!cloudName || !uploadPreset) {
        throw new Error('Vul Cloudinary cloud name en upload preset in.');
      }

      return {
        endpoint: 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloudName) + '/image/upload',
        fields: [
          ['upload_preset', uploadPreset]
        ]
      };
    }

    if (!uploadEndpoint) {
      throw new Error('Vul een uploadEndpoint in.');
    }

    return {
      endpoint: uploadEndpoint,
      fields: []
    };
  }

  function extractUploadResult(payload) {
    return {
      url: payload.secure_url || payload.url || payload.image_url || payload.src || '',
      publicId: payload.public_id || '',
      format: payload.format || ''
    };
  }

  function uploadFile(form, file) {
    var config = getUploadConfig(form);
    var body = new FormData();

    body.append('file', file);

    config.fields.forEach(function (field) {
      body.append(field[0], field[1]);
    });

    return fetch(config.endpoint, {
      method: 'POST',
      body: body
    })
      .then(function (response) {
        return readJson(response).then(function (payload) {
          if (!response.ok) {
            throw new Error(getErrorMessage(payload, 'Upload mislukt. Controleer Cloudinary instellingen.'));
          }

          var result = extractUploadResult(payload);

          if (!result.url) {
            throw new Error('Cloudinary gaf geen afbeelding URL terug.');
          }

          return result;
        });
      });
  }

  function renderSections(sections) {
    if (!sections) return;

    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      var target = document.getElementById('shopify-section-' + sectionId);

      if (!target || !html) return;

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      target.innerHTML = parsed.body.innerHTML;
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) {
          reject(new Error('Printbestand kon niet worden gemaakt.'));
          return;
        }

        resolve(blob);
      }, type, quality);
    });
  }

  function makeSafeFilename(value) {
    return String(value || 'canvas')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getPrintOutputSize(widthCm, heightCm) {
    var outputWidth = Math.round(Number(widthCm) * PRINT_PIXELS_PER_CM);
    var outputHeight = Math.round(Number(heightCm) * PRINT_PIXELS_PER_CM);

    if (!outputWidth || !outputHeight) {
      outputWidth = 3000;
      outputHeight = 4000;
    }

    var longestSide = Math.max(outputWidth, outputHeight);

    if (longestSide > PRINT_MAX_SIDE) {
      var scale = PRINT_MAX_SIDE / longestSide;
      outputWidth = Math.round(outputWidth * scale);
      outputHeight = Math.round(outputHeight * scale);
    }

    return {
      width: outputWidth,
      height: outputHeight
    };
  }

  function createFinalCanvasBlob(preview, image, state) {
    var previewBounds = preview.getBoundingClientRect();
    var outputSize = getPrintOutputSize(state.sizeWidth, state.sizeHeight);

    if (!previewBounds.width || !previewBounds.height) {
      throw new Error('Preview is nog niet klaar.');
    }

    if (!image.naturalWidth || !image.naturalHeight) {
      throw new Error('Afbeelding is nog niet klaar.');
    }

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    canvas.width = outputSize.width;
    canvas.height = outputSize.height;

    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);

    var naturalWidth = image.naturalWidth;
    var naturalHeight = image.naturalHeight;
    var imageRatio = naturalWidth / naturalHeight;
    var previewRatio = previewBounds.width / previewBounds.height;

    var coverWidth;
    var coverHeight;

    if (imageRatio > previewRatio) {
      coverHeight = previewBounds.height;
      coverWidth = previewBounds.height * imageRatio;
    } else {
      coverWidth = previewBounds.width;
      coverHeight = previewBounds.width / imageRatio;
    }

    var displayedWidth = coverWidth * state.zoom;
    var displayedHeight = coverHeight * state.zoom;

    var displayedLeft = previewBounds.width / 2 + state.offsetX - displayedWidth / 2;
    var displayedTop = previewBounds.height / 2 + state.offsetY - displayedHeight / 2;

    var sourceX = (0 - displayedLeft) / displayedWidth * naturalWidth;
    var sourceY = (0 - displayedTop) / displayedHeight * naturalHeight;
    var sourceWidth = previewBounds.width / displayedWidth * naturalWidth;
    var sourceHeight = previewBounds.height / displayedHeight * naturalHeight;

    sourceX = Math.max(0, sourceX);
    sourceY = Math.max(0, sourceY);
    sourceWidth = Math.min(naturalWidth - sourceX, sourceWidth);
    sourceHeight = Math.min(naturalHeight - sourceY, sourceHeight);

    context.drawImage(
      image,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      0,
      0,
      canvas.width,
      canvas.height
    );

    return canvasToBlob(canvas, 'image/jpeg', PRINT_JPEG_QUALITY);
  }

  function initCanvasForm(form) {
    if (form.dataset.canvasReady === 'true') return;
    form.dataset.canvasReady = 'true';

    var root = form.closest('[data-canvas-simple]');
    var preview = root ? root.querySelector('[data-canvas-preview]') : null;
    var image = root ? root.querySelector('[data-canvas-image]') : null;
    var imageMover = root ? root.querySelector('[data-canvas-image-mover]') : null;
    var placeholder = root ? root.querySelector('[data-canvas-placeholder]') : null;
    var uploadButton = root ? root.querySelector('.canvas-simple__upload-button') : null;
    var priceElement = root ? root.querySelector('[data-canvas-price]') : null;

    var variantInput = form.querySelector('[data-canvas-variant-id]');
    var fileInput = form.querySelector('[data-canvas-file]');
    var zoomInput = form.querySelector('[data-canvas-zoom]');
    var status = form.querySelector('[data-canvas-status]');
    var submit = form.querySelector('[data-canvas-submit]');

    var sizeButtons = Array.prototype.slice.call(form.querySelectorAll('[data-canvas-size-button]'));
    var sizeFilterButtons = Array.prototype.slice.call(form.querySelectorAll('[data-canvas-size-filter]'));

    var propertySize = form.querySelector('[data-canvas-property-size]');
    var propertyImageUrl = form.querySelector('[data-canvas-property-image-url]');
    var propertyPrintUrl = form.querySelector('[data-canvas-property-print-url]');
    var propertyPublicId = form.querySelector('[data-canvas-property-public-id]');
    var propertyPrintPublicId = form.querySelector('[data-canvas-property-print-public-id]');
    var propertyZoom = form.querySelector('[data-canvas-property-zoom]');
    var propertyPositionX = form.querySelector('[data-canvas-property-position-x]');
    var propertyPositionY = form.querySelector('[data-canvas-property-position-y]');

    if (!root || !preview || !image || !imageMover || !fileInput || !zoomInput || !submit) return;

    if (uploadButton) {
      uploadButton.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });

      uploadButton.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    var productAvailable = form.dataset.productAvailable === 'true';

    var state = {
      localUrl: '',
      imageUrl: '',
      printUrl: '',
      publicId: '',
      printPublicId: '',
      uploadPromise: null,
      busy: false,
      zoom: toNumber(zoomInput.value, 1),
      offsetX: 0,
      offsetY: 0,
      sizeWidth: 20,
      sizeHeight: 20,
      dragging: false,
      startX: 0,
      startY: 0,
      baseX: 0,
      baseY: 0
    };

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function hasChosenFile() {
      return Boolean(fileInput.files && fileInput.files[0]);
    }

    function updateSubmitState() {
      var canSubmit = productAvailable && !state.busy && hasChosenFile() && Boolean(state.imageUrl);
      submit.disabled = !canSubmit;
    }

    function setBusy(isBusy) {
      state.busy = Boolean(isBusy);
      form.classList.toggle('is-busy', state.busy);
      updateSubmitState();
    }

    function syncProperties() {
      if (propertyImageUrl) propertyImageUrl.value = state.imageUrl || '';
      if (propertyPrintUrl) propertyPrintUrl.value = state.printUrl || '';
      if (propertyPublicId) propertyPublicId.value = state.publicId || '';
      if (propertyPrintPublicId) propertyPrintPublicId.value = state.printPublicId || '';
      if (propertyZoom) propertyZoom.value = state.zoom.toFixed(2);
      if (propertyPositionX) propertyPositionX.value = String(Math.round(state.offsetX));
      if (propertyPositionY) propertyPositionY.value = String(Math.round(state.offsetY));
    }

    function invalidatePrintFile() {
      state.printUrl = '';
      state.printPublicId = '';
      syncProperties();
    }

    function getCoverSize() {
      var bounds = preview.getBoundingClientRect();

      if (!image.naturalWidth || !image.naturalHeight || !bounds.width || !bounds.height) {
        return {
          width: bounds.width,
          height: bounds.height
        };
      }

      var imageRatio = image.naturalWidth / image.naturalHeight;
      var boxRatio = bounds.width / bounds.height;

      if (imageRatio > boxRatio) {
        return {
          width: bounds.height * imageRatio,
          height: bounds.height
        };
      }

      return {
        width: bounds.width,
        height: bounds.width / imageRatio
      };
    }

    function updateImageCoverSize() {
      var coverSize = getCoverSize();

      imageMover.style.setProperty('--canvas-image-width', coverSize.width + 'px');
      imageMover.style.setProperty('--canvas-image-height', coverSize.height + 'px');

      return coverSize;
    }

    function clampOffsets() {
      var bounds = preview.getBoundingClientRect();
      var coverSize = updateImageCoverSize();

      var scaledWidth = coverSize.width * state.zoom;
      var scaledHeight = coverSize.height * state.zoom;

      var maxX = Math.max(0, (scaledWidth - bounds.width) / 2);
      var maxY = Math.max(0, (scaledHeight - bounds.height) / 2);

      state.offsetX = clamp(state.offsetX, -maxX, maxX);
      state.offsetY = clamp(state.offsetY, -maxY, maxY);
    }

    function updateTransform() {
      clampOffsets();

      imageMover.style.setProperty('--canvas-x', state.offsetX + 'px');
      imageMover.style.setProperty('--canvas-y', state.offsetY + 'px');
      imageMover.style.setProperty('--canvas-zoom', String(state.zoom));

      syncProperties();
    }

    function selectSize(button) {
      if (!button) return;

      sizeButtons.forEach(function (item) {
        var selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      root.style.setProperty('--canvas-simple-ratio', button.dataset.sizeRatio || '30 / 40');
root.classList.remove('is-format-square', 'is-format-portrait', 'is-format-landscape');

var selectedWidth = toNumber(button.dataset.sizeWidth, 30);
var selectedHeight = toNumber(button.dataset.sizeHeight, 40);

if (selectedWidth === selectedHeight) {
  root.classList.add('is-format-square');
} else if (selectedWidth < selectedHeight) {
  root.classList.add('is-format-portrait');
} else {
  root.classList.add('is-format-landscape');
}
      state.sizeWidth = selectedWidth;
state.sizeHeight = selectedHeight;

      if (propertySize) {
        propertySize.value = button.dataset.sizeLabel || button.textContent.trim();
      }

      if (variantInput && button.dataset.variantId) {
        variantInput.value = button.dataset.variantId;
      }

      if (priceElement && button.dataset.price) {
        priceElement.textContent = button.dataset.price;
      }

      if (typeof button.dataset.available !== 'undefined') {
        productAvailable = button.dataset.available === 'true';
      }

      state.offsetX = 0;
      state.offsetY = 0;

      invalidatePrintFile();
      updateTransform();
      updateSubmitState();
    }

    function setSizeFilter(filter, autoSelect) {
      var firstVisibleButton = null;
      var selectedVisible = false;

      sizeFilterButtons.forEach(function (button) {
        var selected = button.dataset.filter === filter;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      sizeButtons.forEach(function (button) {
        var matches = filter === 'all' || button.dataset.sizeGroup === filter;

        button.hidden = !matches;

        if (matches && !button.disabled && !firstVisibleButton) {
          firstVisibleButton = button;
        }

        if (matches && button.classList.contains('is-selected')) {
          selectedVisible = true;
        }
      });

      if (autoSelect && !selectedVisible && firstVisibleButton) {
        selectSize(firstVisibleButton);
      }
    }

    function resetImage() {
      if (state.localUrl) {
        URL.revokeObjectURL(state.localUrl);
      }

      state.localUrl = '';
      state.imageUrl = '';
      state.printUrl = '';
      state.publicId = '';
      state.printPublicId = '';
      state.uploadPromise = null;
      state.offsetX = 0;
      state.offsetY = 0;
      state.zoom = 1;

      image.onload = null;
      image.onerror = null;
      image.src = TRANSPARENT_GIF;
      imageMover.hidden = true;
      root.classList.remove('has-image');

      if (placeholder) placeholder.hidden = false;

      zoomInput.value = '1';
      zoomInput.disabled = true;

      syncProperties();
      setStatus('');
      updateSubmitState();
    }

    function uploadFinalPrintFile() {
      if (!state.localUrl || !image.naturalWidth || !image.naturalHeight) {
        throw new Error('Upload eerst een foto.');
      }

      setStatus('Printbestand wordt gemaakt...');

      return createFinalCanvasBlob(preview, image, state)
        .then(function (blob) {
          var sizeName = propertySize ? propertySize.value : 'canvas';
          var filename = 'print-' + makeSafeFilename(sizeName) + '-' + Date.now() + '.jpg';
          var file;

          try {
            file = new File([blob], filename, {
              type: 'image/jpeg'
            });
          } catch (error) {
            blob.name = filename;
            file = blob;
          }

          setStatus('Printbestand wordt geüpload...');
          return uploadFile(form, file);
        })
        .then(function (result) {
          state.printUrl = result.url || '';
          state.printPublicId = result.publicId || '';

          if (!state.printUrl) {
            throw new Error('Cloudinary gaf geen printbestand URL terug.');
          }

          syncProperties();
          return result;
        });
    }

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selectSize(button);
      });
    });

    var selectedSizeButton = sizeButtons.filter(function (button) {
      return button.classList.contains('is-selected');
    })[0];

    selectSize(selectedSizeButton || sizeButtons[0]);

    sizeFilterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setSizeFilter(button.dataset.filter || 'all', true);
      });
    });

    setSizeFilter('all', false);

    zoomInput.addEventListener('input', function () {
      var min = toNumber(zoomInput.min, 1);
      var max = toNumber(zoomInput.max, 3);

      state.zoom = clamp(toNumber(zoomInput.value, 1), min, max);

      invalidatePrintFile();
      updateTransform();
    });

    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];

      if (!file) {
        resetImage();
        return;
      }

      if (!file.type || file.type.indexOf('image/') !== 0) {
        fileInput.value = '';
        resetImage();
        setStatus('Kies een afbeeldingsbestand.');
        return;
      }

      if (state.localUrl) {
        URL.revokeObjectURL(state.localUrl);
      }

      state.localUrl = URL.createObjectURL(file);
      state.imageUrl = '';
      state.printUrl = '';
      state.publicId = '';
      state.printPublicId = '';
      state.offsetX = 0;
      state.offsetY = 0;
      state.zoom = 1;

      image.onload = function () {
        state.offsetX = 0;
        state.offsetY = 0;
        updateTransform();
      };

      image.onerror = function () {
        fileInput.value = '';
        resetImage();
        setStatus('Afbeelding kon niet worden geladen.');
      };

      image.src = state.localUrl;
      imageMover.hidden = false;
      root.classList.add('has-image');

      if (placeholder) placeholder.hidden = true;

      zoomInput.value = '1';
      zoomInput.disabled = false;

      updateTransform();
      setBusy(true);

      if ((form.dataset.uploadProvider || 'endpoint') === 'cloudinary') {
        setStatus('Foto wordt naar Cloudinary geüpload...');
      } else {
        setStatus('Foto wordt naar uploadEndpoint geüpload...');
      }

      state.uploadPromise = uploadFile(form, file)
        .then(function (result) {
          state.imageUrl = result.url || '';
          state.publicId = result.publicId || '';
          state.printUrl = '';
          state.printPublicId = '';

          syncProperties();
          setStatus('Foto is klaar.');
          return result;
        })
        .catch(function (error) {
          state.imageUrl = '';
          state.printUrl = '';
          state.publicId = '';
          state.printPublicId = '';

          syncProperties();
          setStatus(error.message || 'Upload mislukt.');
          return null;
        })
        .then(function (result) {
          state.uploadPromise = null;
          setBusy(false);
          return result;
        });
    });

    preview.addEventListener('pointerdown', function (event) {
      if (event.target.closest('.canvas-simple__upload-button')) return;
      if (event.target.closest('[data-canvas-file]')) return;
      if (imageMover.hidden) return;

      event.preventDefault();

      state.dragging = true;
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.baseX = state.offsetX;
      state.baseY = state.offsetY;

      preview.classList.add('is-dragging');

      if (preview.setPointerCapture) {
        preview.setPointerCapture(event.pointerId);
      }
    });

    preview.addEventListener('pointermove', function (event) {
      if (!state.dragging) return;

      state.offsetX = state.baseX + event.clientX - state.startX;
      state.offsetY = state.baseY + event.clientY - state.startY;

      invalidatePrintFile();
      updateTransform();
    });

    function endDrag(event) {
      if (!state.dragging) return;

      state.dragging = false;
      preview.classList.remove('is-dragging');

      if (preview.releasePointerCapture) {
        try {
          preview.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }

      updateTransform();
    }

    preview.addEventListener('pointerup', endDrag);
    preview.addEventListener('pointercancel', endDrag);
    preview.addEventListener('pointerleave', endDrag);

    window.addEventListener('resize', function () {
      if (!imageMover.hidden) {
        updateTransform();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (state.busy) return;

      setBusy(true);
      setStatus('Bezig met voorbereiden...');

      Promise.resolve(state.uploadPromise)
        .then(function () {
          if (!state.imageUrl) {
            throw new Error('Upload eerst een foto.');
          }

          return uploadFinalPrintFile();
        })
        .then(function () {
          syncProperties();

          var body = new FormData(form);

          if (variantInput && variantInput.value) {
            body.set('id', variantInput.value);
          }

          var sections = form.querySelector('[name="sections"]');
          var sectionsUrl = form.querySelector('[name="sections_url"]');

          if (sections && sections.value) {
            body.set('sections', sections.value);
          }

          body.set('sections_url', sectionsUrl && sectionsUrl.value ? sectionsUrl.value : window.location.pathname);

          setStatus('Bezig met toevoegen...');

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: body
          });
        })
        .then(function (response) {
          return readJson(response).then(function (payload) {
            if (!response.ok) {
              throw new Error(getErrorMessage(payload, 'Toevoegen is mislukt.'));
            }

            renderSections(payload.sections);
            document.dispatchEvent(new CustomEvent('canvas-simple:added', { detail: payload }));
            setStatus('Toegevoegd aan winkelwagen.');
          });
        })
        .catch(function (error) {
          setStatus(error.message || 'Er ging iets mis.');
        })
        .then(function () {
          setBusy(false);
        });
    });

    updateTransform();
    updateSubmitState();
  }

  function initAll(scope) {
    var root = scope || document;

    Array.prototype.slice.call(root.querySelectorAll(FORM_SELECTOR)).forEach(function (form) {
      initCanvasForm(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();